module.exports = __webpack_public_path__ + "f8fd3554f6564f7e37f1f1179b7ceef2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-70.png
// module id = 141
// module chunks = 0